<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          routeBack="AdminIndex"
          class="truncate"
          :title="$t('Admin') + ' - ' + getValue('tostring')"/>
        <show-actions
          :deleteItem=allowDelete
          :editItem=allowEdit
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm" v-if="admin">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('admin.lastName')}}</div>
                  <div> {{ getValue('lastName') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('admin.firstName')}}</div>
                  <div> {{ getValue('firstName') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('admin.phoneNumber') }}</div>
                  <div> {{ getValue('phoneNumber') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('admin.username') }}</div>
                  <div> {{ getValue('username') }}</div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selectedItem="admin"
      controllerName="admin"
      itemSingularName="admin"
      itemSingularNameUpp="Admin"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'AdminShow',

  components: {
    ShowActions,
    BackArrow,
    ItemDeleteModal

  },

  data () {
    return {
      adminId: this.$route.params.adminId,
      admin: {},
      allowDelete: false,
      allowEdit: false
    }
  },

  computed: {
    getValue() {
      return (path) => {
        const properties = path.split('.');
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null;
        }, this.admin);
        return value !== null ? value : 'N/A';
      };
    },
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    async fetchData () {
      if (this.adminId) {
        await this.fetchAdmin()
      }
    },

    async fetchAdmin () {
      api
        .get('/admin/' + this.adminId)
        .then(response => {
          this.allowEdit = !response.data.role.includes('ROLE_SUPER_ADMIN')
          this.allowDelete = !response.data.role.includes('ROLE_SUPER_ADMIN')
          this.admin = response.data
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'AdminEdit',
        params: {
          adminId: this.admin.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.$router.push({
        name: 'AdminIndex'
      })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/AdminShow.vue